"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getPointAtLength = void 0;
const construct_1 = require("./helpers/construct");
const get_part_at_length_1 = require("./helpers/get-part-at-length");
/**
 * @description Gets the coordinates of a point which is on an SVG path.
 * @param {string} path A valid SVG path
 * @param {number} length The length at which the point should be sampled
 * @see [Documentation](https://remotion.dev/docs/paths/get-point-at-length)
*/
const getPointAtLength = (path, length) => {
    const constructed = (0, construct_1.construct)(path);
    const fractionPart = (0, get_part_at_length_1.getPartAtLength)(path, length);
    const functionAtPart = constructed.functions[fractionPart.i];
    if (functionAtPart) {
        return functionAtPart.getPointAtLength(fractionPart.fraction);
    }
    if (constructed.initial_point) {
        return constructed.initial_point;
    }
    throw new Error('Wrong function at this part.');
};
exports.getPointAtLength = getPointAtLength;
